import React, { useEffect } from 'react';
import { PromoBanner } from '../components/PromoBanner';
import { HeroImage } from '../components/HeroImage';
import { SectionImage } from '../components/SectionImage';
import { SectionImage2 } from '../components/SectionImage2';
import { SectionImage3 } from '../components/SectionImage3';
import { ProductSection } from '../components/ProductSection';
import { SectionImage4 } from '../components/SectionImage4';
import { ReviewsSection } from '../components/ReviewsSection';
import { SectionImageDouble } from '../components/SectionImageDouble';
import { SectionImage5 } from '../components/SectionImage5';
import { ReviewsSectionNew } from '../components/ReviewsSectionNew';
import { OfertaSection } from '../components/OfertaSection';
import { FaqSection } from '../components/FaqSection';
const BASE_PRICES = {
  productOriginal: 58.95,
  productFinal: 13.95,
  productSave: 55,
  bonusOriginal: 148.65,
  bonusSave: 135.7
};
function formatPrice(value: number, currency: string): string {
  try {
    return new Intl.NumberFormat('es', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: currency === 'COP' || currency === 'CLP' || currency === 'PYG' || currency === 'ARS' ? 0 : 2,
      maximumFractionDigits: currency === 'COP' || currency === 'CLP' || currency === 'PYG' || currency === 'ARS' ? 0 : 2
    }).format(value);
  } catch {
    return '€' + value.toFixed(2);
  }
}
function updatePrices(rate: number, currency: string) {
  const productOriginal = BASE_PRICES.productOriginal * rate;
  const productFinal = BASE_PRICES.productFinal * rate;
  const productSave = BASE_PRICES.productSave * rate;
  const bonusOriginal = BASE_PRICES.bonusOriginal * rate;
  const bonusSave = BASE_PRICES.bonusSave * rate;
  document.querySelectorAll('.price-original-product').forEach(el => {
    el.textContent = formatPrice(productOriginal, currency);
  });
  document.querySelectorAll('.price-final-product').forEach(el => {
    el.textContent = formatPrice(productFinal, currency);
  });
  document.querySelectorAll('.price-save-product').forEach(el => {
    el.textContent = 'AHORRA ' + formatPrice(productSave, currency);
  });
  document.querySelectorAll('.price-original-bonus').forEach(el => {
    el.textContent = formatPrice(bonusOriginal, currency);
  });
  document.querySelectorAll('.price-save-bonus').forEach(el => {
    el.textContent = 'Ahorras ' + formatPrice(bonusSave, currency);
  });
}
function initPricing() {
  fetch('https://ipapi.co/json/').then(res => res.json()).then(data => {
    const currency = data && data.currency ? data.currency : 'EUR';
    // If already EUR, no conversion needed
    if (currency === 'EUR') {
      updatePrices(1, 'EUR');
      return;
    }
    // Fetch live exchange rates from open.er-api.com (supports 150+ currencies worldwide)
    fetch('https://open.er-api.com/v6/latest/EUR').then(res => res.json()).then(ratesData => {
      const rates = ratesData && ratesData.rates ? ratesData.rates : {};
      const rate = rates[currency];
      if (rate && rate > 0) {
        updatePrices(rate, currency);
      } else {
        // Currency not found, show in EUR
        updatePrices(1, 'EUR');
      }
    }).catch(() => {
      updatePrices(1, 'EUR');
    });
  }).catch(() => {
    updatePrices(1, 'EUR');
  });
}
export function LandingPage() {
  useEffect(() => {
    initPricing();
  }, []);
  useEffect(() => {
    window.addEventListener('load', () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' as ScrollBehavior
      });
    });
    // Also force scroll immediately in case load already fired
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, []);
  return <main className="w-full min-h-screen" data-id="element-127">
      <PromoBanner data-id="element-128" />
      <HeroImage data-id="element-129" />
      <SectionImage data-id="element-130" />
      <SectionImage2 data-id="element-131" />
      <SectionImage3 data-id="element-132" />
      <ProductSection data-id="element-133" />
      <SectionImage4 data-id="element-134" />
      <ReviewsSection data-id="element-135" />
      <SectionImageDouble data-id="element-136" />
      <SectionImage5 data-id="element-137" />
      <ReviewsSectionNew data-id="element-138" />
      <OfertaSection data-id="element-139" />
      <FaqSection data-id="element-140" />
    </main>;
}